import { useHookstate } from "@hookstate/core";
import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import { MsgToSelectedCarsCmp } from "commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/MsgToSelectedCars";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";

const SendMsgToCars = () => {
	const { showMessageBoxForSingleCar } = useHookstate(MAP_GLOBAL_STATES);
	const style = {
		position: "absolute", //map > car > msg
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: "320px",
		bgcolor: "#ffffff",
		zIndex: 1,
	};

	return ( 
		<Modal
		// open={isLoading.get()}
		open={showMessageBoxForSingleCar.get()}
		// onClose={handleClose}
		onClose={() => showMessageBoxForSingleCar.set(false)}
		aria-labelledby="modal-modal-title"
		aria-describedby="modal-modal-description"
		>
			<Box sx={style}>
				<MsgToSelectedCarsCmp cancelClick={() => showMessageBoxForSingleCar.set(false)} />
			</Box>
		</Modal>
	);
}
 
export default SendMsgToCars;